<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';
import ChunksDialog from './ChunksDialog.vue';

const { t } = useI18n();
const chunksDialog = ref(null);

const openDialog = () => {
  chunksDialog.value.open();
};
</script>

<template>
  <div class="fixed bottom-20 ltr:right-4 rtl:left-4 z-50">
    <ButtonGroup
      class="rounded-full bg-n-alpha-2 backdrop-blur-lg p-1 shadow hover:shadow-md"
    >
      <Button
        icon="i-lucide-braces"
        no-animation
        :title="t('CAPTAIN.RESPONSES.CHUNKS_BUTTON')"
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl transition-all duration-200 ease-out hover:brightness-110"
        lg
        @click="openDialog"
      />
    </ButtonGroup>
  </div>
  <ChunksDialog ref="chunksDialog" />
</template>
